import script from "./AchieveDashboardStats.vue?vue&type=script&setup=true&lang=js"
export * from "./AchieveDashboardStats.vue?vue&type=script&setup=true&lang=js"

import "./AchieveDashboardStats.vue?vue&type=style&index=0&id=33f5b98c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33f5b98c"]])

export default __exports__